import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft, Check } from "lucide-react";
import { api } from "../api";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/password/forgot", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Couldn't send the reset link. Please try again.");
      toast.error("Reset request failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-20 pb-32" data-testid="forgot-password-page">
      <Link to="/login" className="font-mono-label text-[10px] text-neutral-500 hover:text-white inline-flex items-center gap-1 mb-6"><ArrowLeft size={11} /> BACK TO SIGN IN</Link>
      <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3">PASSWORD RESET</div>
      <h1 className="font-display text-5xl uppercase leading-none mb-8">Forgot Password</h1>

      {sent ? (
        <div className="border border-[var(--accent)] p-6 bg-[#1a0a05]" data-testid="forgot-sent">
          <div className="w-10 h-10 border border-[var(--accent)] flex items-center justify-center mb-4">
            <Check size={16} className="text-[var(--accent)]" />
          </div>
          <h2 className="font-headline text-xl uppercase mb-2">Check Your Inbox</h2>
          <p className="text-neutral-300 text-sm mb-3">If <span className="text-[var(--accent)]">{email}</span> matches an account, a reset link is on the way.</p>
          <p className="font-mono-label text-[9px] text-neutral-500">LINK EXPIRES IN 60 MINUTES · SINGLE-USE ONLY.</p>
          <div className="mt-4 flex items-center gap-3">
            <Link to="/login" className="btn-ghost" data-testid="forgot-back-login">Back to Sign In</Link>
            <button onClick={() => setSent(false)} className="font-mono-label text-[10px] text-neutral-400 hover:text-[var(--accent)]" data-testid="forgot-resend">RESEND</button>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="relative">
            <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" />
            <input type="email" required placeholder="Your email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-brut !pl-9" data-testid="forgot-email" />
          </div>
          {err && <p className="text-[var(--accent)] font-mono-label text-xs" data-testid="forgot-error">{err}</p>}
          <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="forgot-submit">
            {busy ? "Sending…" : "Send reset link"}
          </button>
          <p className="font-mono-label text-[10px] text-neutral-500">We'll never share your email. Reset links expire in 60 minutes.</p>
        </form>
      )}
    </div>
  );
}
